if (!customElements.get('product-tabs')) {
      class productTabs extends HTMLElement {
      constructor() {
        super();
        let thisElement = this;
        this.liElement = this.querySelectorAll('.tabs-button-element');
        if(this.liElement){
          this.liElement.forEach(function(button){
            button.addEventListener('click',function(){
              let contentBackground = this.dataset.contentBackground;
              let imageBackground = this.dataset.imageBackground;
              let dataValue = this.dataset.value;
              thisElement.querySelector('.product-image.show').classList.remove('show');
              thisElement.querySelector('.product-image[data="'+dataValue+'"]').classList.add('show');
              thisElement.style.setProperty('--content-background', contentBackground);
              thisElement.style.setProperty('--image-background', imageBackground);
            });
          });
        }
      }
    }
    // Define the custom countdown-clock element
    customElements.define('product-tabs', productTabs);
  }
  